import { Badge, Button, cn, Icon, Tooltip, TooltipContent, TooltipTrigger } from "@qw/ui";
import type { FC } from "react";

import { useDraft } from "../../providers/draft-provider";

export const DraftCardHeaderActions: FC = () => {
  const { placement, isMinimized, isScheduled, isScheduledFailed, handleOpenFloating } = useDraft();

  return (
    <>
      {isScheduled && (
        <Tooltip>
          <TooltipTrigger asChild>
            <Badge
              variant="primary"
              className={cn("pl-2.5 gap-1.5 bg-primary/10 text-primary mr-1", {
                "px-0.5!": isMinimized,
              })}
            >
              <Icon icon="schedule_send" />
              {!isMinimized && "Scheduled"}
            </Badge>
          </TooltipTrigger>
          <TooltipContent hidden={!isMinimized}>Scheduled</TooltipContent>
        </Tooltip>
      )}
      {isScheduledFailed && (
        <Tooltip>
          <TooltipTrigger asChild>
            <Badge
              variant="destructive"
              className={cn("gap-1 bg-destructive/10 text-destructive mr-1", {
                "px-0.5!": isMinimized,
              })}
            >
              <Icon icon="error" />
              {!isMinimized && "Failed"}
            </Badge>
          </TooltipTrigger>
          <TooltipContent hidden={!isMinimized}>Failed</TooltipContent>
        </Tooltip>
      )}
      {placement === "inline" && (
        <Button variant="ghost" size="xs" onClick={handleOpenFloating} aria-label="Open floating editor">
          <Icon icon="open_in_new" />
        </Button>
      )}
    </>
  );
};
